import grid from "../../scss/flexboxgrid.module.scss";
import view from "./directions.module.scss";
import darkView from "./darkDirections.module.scss";
import FindDealerMap from "./findDealerMap";
import React, { useState } from "react";

const FindLocations = (props) => {
  // console.log(props.props.data)

  const {
    dealerAddress,
    dealerName,
    serviceHours,
    salesHours,
    dealerLogo,
    addtlLoc,
  } = props.props.data;

  const darkMapMode = props.props.data.darkMapMode || true;
  const [origin, setOrigin] = useState("");
  
  const getDirections = (location) => {
    const baseURL = "https://www.google.com/maps/dir/";
    const escapedOrigin = String(origin)
      .replaceAll(" ", "+")
      .replaceAll("#", "%23");
    const destiny = String(location).replaceAll(' ', '+').replaceAll('#','%23')
    window.open(`${baseURL}${escapedOrigin}/${destiny}`)
  };

//   const renderHours = (hours) => (
//     <div className={darkMapMode ? darkView["hour-wrap"] : view["hour-wrap"]}>
//       {hours.map((el, index) => (
//         <div
//           key={index}
//           className={darkMapMode ? darkView["hour-cont"] : view["hour-cont"]}
//         >
//           <span>{el.day}</span>
//           <span>{el.time}</span>
//         </div>
//       ))}
//     </div>
//   );

  const renderSearch = (location) => (
    <div
      className={darkMapMode ? darkView["search-cont"] : view["search-cont"]}
    >
      <input
        id="search-dir-input"
        className={darkMapMode ? darkView["search-dir"] : view["search-dir"]}
        placeholder={"Enter starting address"}
        onChange={(e) => setOrigin(e.target.value)}
      />
      <button
        className={darkMapMode ? darkView["search-btn"] : view["search-btn"]}
        onClick={() => getDirections(location)}
      >
        <p
          style={{ position: "relative", top: "-4px", transform: "scaleX(-1)" }}
        >
          &#x2315;
        </p>
      </button>
    </div>
  );

  return (
    <div className={darkMapMode ? darkView["directions"] : view["directions"]}>
      <div className={darkMapMode ? darkView["dir-left"] : view["dir-left"]}>
        <div
          className={darkMapMode ? darkView["left-wrap"] : view["left-wrap"]}
          style={{maxHeight: "100%", overflow:"hidden"}}
        >
          <div
            className={
              darkMapMode ? darkView["dealerNameWrap"] : view["dealerNameWrap"]
            }
          >
            {/* <div
              className={
                darkMapMode
                  ? darkView["dealerNameLogo"]
                  : view["dealerNameLogo"]
              }
            >
              <img src={dealerLogo} alt={dealerName} />
            </div> */}
            <div
              className={
                darkMapMode
                  ? darkView["dealerNameInfo"]
                  : view["dealerNameInfo"]
              }
            >
              <h2
                className={`${
                  darkMapMode ? darkView["dealerName"] : view["dealerName"]
                } dealerName`}
              >
                Where To Find Us
              </h2>
            </div>
          </div>
          {/* <label htmlFor="search-dir-input">{`Get directions to ${dealerName}`}</label>
          {renderSearch()} */}

          <div
            className={darkMapMode ? darkView["dir-cols"] : view["dir-cols"]}
            style={{ maxHeight:"40rem"}}
          >
            {addtlLoc.map((location, index) => (
                <div key={index}>
                    <>
                         <h2>{location.name}</h2> 
                        <h3 className={darkMapMode ? darkView["col-head"] : view["col-head"]}>{location.address}</h3>
                        {location.phone ? <p style={{paddingBlock: ".5em"}} ><b>Phone:</b> <a style={{color:"white"}} href={`tel:${location.phone}`}>{location.phone}</a></p> : ''}
                        {location.locHours ? <p><b>Hours</b></p>:''}
                        {location.locHours ? location.locHours.map((day, index) => (
                          
                                <p key={index} style={{paddingTop: ".5em", fontSize:"14px"}}><b>{day.day}:</b> {day.time}</p>
                            
                        )) : ''}
                        <br></br>
                        <label htmlFor="search-dir-input" style={{paddingTop: ".5em"}}>{`Get directions`}</label>
                        {renderSearch(location.lat + ',' + location.lng)}
                    </>
                </div>
            ))}
          
          </div>
        </div>
      </div>
      <div className={darkMapMode ? darkView["dir-right"] : view["dir-right"]}>
        <div
          className={darkMapMode ? darkView["right-wrap"] : view["right-wrap"]}
        >
          <FindDealerMap props={props} />
        </div>
      </div>
    </div>
  );
};

export default FindLocations;

// FindLocations.defaultProps = {
//     data: [{
//         name:'',
//         adr:'',
//         lat:'',
//         long:'',
//         phone:'',
//         hours:[
//             {day:'', time:''}
//         ] //more?

//     },{
//         name:'',
//         adr:'',
//         lat:'',
//         long:'',
//         phone:'',
//         hours:[
//             {day:'', time:''}
//         ] //more?
//     }]
//   }